import { TableHeadersType } from "./tableHeadersConstants/tableHeadersType"

export const INVOICE_EXPENSE_HEADER = [
    {
        "label": "Name",
        "value": "name",
        "defaultChecked": true,
        "checked": true
    },
       {
        "label": "Invoice/Voucher No.",
        "value": "bill_number",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Date Of Invoice",
        "value": "voucher_invoice_date",
        "defaultChecked": true,
        "checked": true
        // Date of Invoice/Voucher Invoice Date/ voucher_invoice_date
    },

    {
        "label": "Date of Payment",
        "value": "dop_in_bank_cash",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Total Amount",
        "value": "invoice_value",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Last Modified By",
        "value": "updated_by",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Date Added/Modified",
        "value": "updated_at",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Upload",
        "value": "upload",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Payment",
        "value": "net_payment_made",
        "defaultChecked": true,
        "checked": true
    }
]

export const PAGINATION_INITIAL={
    // activePage:1,
    limit: 10,
    pageNumber: 0,
    startCount: 1,
    endCount: 10,
    next: true,
    prev: false,
}
export const INVOICE_REVENUE_HEADER = [
    {
        "label": "Name",
        "value": "name",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Invoice/Voucher No.",
        "value": "bill_number",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Date Of Invoice",
        "value": "invoice_voucher_date",
        "defaultChecked": true,
        "checked": true
        // Date of Invoice/Voucher Invoice Date/ voucher_invoice_date
    },

    {
        "label": "Date of Reciept",
        "value": "dor_in_bank_cash",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Total Amount",
        "value": "invoice_value",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Last Modified By",
        "value": "updated_by",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Date Added/Modified",
        "value": "updated_at",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Upload",
        "value": "upload",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Payment",
        "value": "net_amount_received",
        "defaultChecked": true,
        "checked": true
    }
]

export const INVOICE_OTHERS_HEADER = [

    {
        "label": "Name",
        "value": "name",
        "defaultChecked": true,
        "checked": true
        // Date of Invoice/Voucher Invoice Date/ voucher_invoice_date
    },

    {
        "label": "From Bank",
        "value": "from_bank",
        "defaultChecked": true,
        "checked": true
    },   
    {
        "label": "From Cash",
        "value": "from_cash",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "From Party",
        "value": "from_party",
        "defaultChecked": true,
        "checked": true
    },   
     {
        "label": "To Bank",
        "value": "to_bank",
        "defaultChecked": true,
        "checked": true
    },    {
        "label": "To Cash",
        "value": "to_cash",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Total Amount",
        "value": "amount",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Last Modified By",
        "value": "updated_by",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Date Added/Modified",
        "value": "updated_at",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Upload",
        "value": "upload",
        "defaultChecked": true,
        "checked": true
    },
    // {
    //     "label": "Payment",
    //     "value": "net_payment_made",
    //     "defaultChecked": true,
    //     "checked": true
    // }
]

export const FILTER_PAYMENT_FORMAT = [
    {
        "label": "All Status",
        "value": "10",
        "defaultChecked": true,
        "checked": true,
        "_id":"payment1"
    },
    {
        "label": "Partial Paid",
        "value": "1",
        "defaultChecked": true,
        "checked": true,
        "_id":"payment2"
    },
    {
        "label": "Pending",
        "value": "0",
        "defaultChecked": true,
        "checked": true,
        "_id":"payment3"
    },
    {
        "label": "Paid",
        "value": "2",
        "defaultChecked": true,
        "checked": true,
        "_id":"payment4"
    },
    {
        "label": "Purchase Order",
        "value": "3",
        "defaultChecked": true,
        "checked": true,
        "_id":"payment5"
    },
]

 
export const FILTER_PAYMENT_FORMAT_PURCHASE = [
    {
        "label": "All Status",
        "value": "10",
        "defaultChecked": true,
        "checked": true,
        "_id":"payment1"
    },
    {
        "label": "Partial Paid",
        "value": "1",
        "defaultChecked": true,
        "checked": true,
        "_id":"payment2"
    },
    {
        "label": "Pending",
        "value": "0",
        "defaultChecked": true,
        "checked": true,
        "_id":"payment3"
    },
    {
        "label": "Paid",
        "value": "2",
        "defaultChecked": true,
        "checked": true,
        "_id":"payment4"
    },
    {
        "label": "Estimation",
        "value": "3",
        "defaultChecked": true,
        "checked": true,
        "_id":"payment5"
    },
]

export const ALLOCATION_HEADER: TableHeadersType[]=[
    {
        "label": "INVOICE NO.",
        "value": "invoice_no",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "INVOICE DATE",
        "value": "invoice_date",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "TOTAL AMOUNT",
        "value": "total_amount",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "ALLOCATE AMOUNT",
        "value": "allocate_amount",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "REMAINING AMOUNT",
        "value": "remaining_amount",
        "defaultChecked": true,
        "checked": true
    }
]




export const EINVOICE_HEADERS : TableHeadersType[]=[
    {
        "label": "SERIAL NO.",
        "value": "item_serial_number",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "PRODUCT DESCRIPTION",
        "value": "product_description",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "UNIT",
        "value": "unit",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "QUANTITY",
        "value": "quantity",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "HSN CODE",
        "value": "hsn_code",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "DISCOUNT",
        "value": "discount",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "UNIT PRICE",
        "value": "unit_price",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "TOTAL AMOUNT",
        "value": "total_amount",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "ASSESSABLE VALUE",
        "value": "assessable_value",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "GST RATE",
        "value": "gst_rate",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "IGST AMOUNT",
        "value": "igst_amount",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "SGST VALUE",
        "value": "sgst_amount",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "CGST RATE",
        "value": "cgst_amount",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "TOTAL ITEM VALUE",
        "value": "total_item_value",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "SERVICE",
        "value": "is_service",
        "defaultChecked": true,
        "checked": true
    }

]

export const EWayBill_HEADERS: TableHeadersType[] = [
    {
        "label": "SERIAL NO.",
        "value": "item_serial_number",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "DESCRIPTION AS PER BILL",
        "value": "product_description",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "SKU CODE",
        "value": "unit_of_product",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "QUANTITY",
        "value": "quantity",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "HSN/SAC Code",
        "value": "hsn_code",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "DISCOUNT",
        "value": "discount",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "AMOUNT",
        "value": "total_amount",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "GST PERCENTAGE",
        "value": "gst_rate",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "IGST PERCENTAGE",
        "value": "igst_rate",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "SGST PERCENTAGE",
        "value": "sgst_rate",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "CGST PERCENTAGE",
        "value": "cgst_rate",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "TOTAL VALUE",
        "value": "total_item_value",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "IS SERVICE",
        "value": "is_service",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "TAXABLE VALUE",
        "value": "taxable_amount",
        "defaultChecked": true,
        "checked": true
    },
]
